import { inject, Injectable, OnDestroy, Signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { LoadKey, loadKey } from "./models/loadKey";
import { Observable } from "rxjs";
import { IsLoadingService } from "./is-loading.service";
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';


@Injectable()
export abstract class _BaseLoadingService
{
    abstract add(): void;
    abstract clear(): void;
    abstract remove(): void;
    abstract addCount(value: number): void;
    abstract removeCount(value: number): void;
    abstract reset(): void;

    protected _isLoadingService = injectRequired(IsLoadingService);

    isLoading$: Observable<boolean>;
    isLoading$$: Signal<boolean>;

    constructor(
        protected _key?: LoadKey | null
    ) {
        this.isLoading$ = this._isLoadingService.isLoading$({key: this._key});
        this.isLoading$$ = toSignal(this.isLoading$, { initialValue: false });
    }

    protected _add(key?: LoadKey): void {
        this._isLoadingService.add({key: key ?? this._key});
    }

    protected _addCount(value: number): void {
        for (let index = 0; index < value; index++) {
            this.add();
        }
    }

    protected _clear(key?: LoadKey): void {
        this._isLoadingService.clear({key: key ?? this._key});
    }

    protected _isLoading$(key?: LoadKey): Observable<boolean> {
        return this._isLoadingService.isLoading$({key: key ?? this._key});
    }

    protected _remove(key?: LoadKey): void {
        this._isLoadingService.remove({key: key ?? this._key});
    }

    protected _removeCount(count: number): void {
        for (let index = 0; index < count; index++) {
            this.remove();
        }
    }

    protected _reset(): void {
        this._isLoadingService.clear({key: Object.values(loadKey)});
    }
}
